<template>
  <div class="home columns is-centered is-vcentered is-mobile">
    <div class="column is-full-mobile is-two-fifths-tablet">
      <div class="nav has-background-light level-item">
        <figure>
          <img
            alt="logo-albaugh"
            class="logo"
            src="../assets/images/logo.png"
          />
        </figure>
      </div>
      <div class="section has-background-white">
        <h1 class="content has-text-centered is-size-5">Faça seu login</h1>
        <form @submit.prevent>
          <div class="field">
            <label class="label">Email</label>
            <div class="control has-icons-left has-icons-right">
              <input
                :class="{ 'is-danger': hasError }"
                class="input"
                placeholder="name@albaugh.com"
                type="email"
                v-model.lazy="email"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
              <span class="icon is-small is-right" v-if="hasError">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="hasError">This email is invalid</p>
          </div>
          <div class="field">
            <label class="label">Senha</label>
            <div class="control has-icons-left has-icons-right">
              <input
                :class="{ 'is-danger': hasError }"
                class="input"
                type="password"
                v-model.lazy="password"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-key"></i>
              </span>
              <span class="icon is-small is-right" v-if="hasError">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="hasError">
              This password is invalid
            </p>
          </div>
          <p
            v-if="forgotPasswordFlag"
            class="help is-danger has-text-centered subtitle is-6"
          >
            Entrar em contato com a equipe de SAP da Albaugh
          </p>
          <div class="level is-mobile remember">
            <div class="level-left">
              <div class="level-item">
                <div class="field">
                  <div class="control">
                    <label class="checkbox" for="remember"></label>
                    <input id="remember" type="checkbox" v-model="remember" />
                    Lembrar me
                  </div>
                </div>
              </div>
            </div>
            <div class="level-right">
              <p class="level-item">
                <a
                  class="has-text-info"
                  href=""
                  @click.prevent="forgotPassword()"
                  >Esqueci a senha</a
                >
              </p>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <button
                @click="buttonLogin"
                class="button is-large is-primary is-fullwidth"
                :class="{ 'is-loading': loading }"
              >
                Entrar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { login } from "../repository.js";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      hasError: false,
      loading: false,
      forgotPasswordFlag: false,
      remember: false,
    };
  },
  created() {
    if (window.localStorage.getItem("email")) {
      this.email = window.localStorage.getItem("email");
      this.remember = true;
    }

    window.sessionStorage.clear();
  },
  methods: {
    buttonLogin() {
      this.getLogin(this.email, this.password);
    },
    async getLogin(user, password) {
      try {
        this.loading = true;
        const { data } = await login(user, password);
        window.localStorage.setItem("userId", data.userId);
        window.sessionStorage.setItem("isLogged", true);
        this.remember
          ? window.localStorage.setItem("email", this.email)
          : window.localStorage.removeItem("email");
        this.$router.push({ name: "list" });
      } catch (err) {
        console.log(err);
        this.hasError = true;
      } finally {
        this.loading = false;
      }
    },
    forgotPassword() {
      this.forgotPasswordFlag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  height: 63px;
  margin-bottom: 0;
}

@media screen and (min-width: 769px) {
  .nav {
    margin-bottom: 24px;
  }
}

.column {
  padding-bottom: 0;
}

.remember {
  margin: 24px 0 32px 0;
}

.home {
  min-height: 100vh;
  font-size: 14px;
}

@media screen and (min-width: 769px) {
  .home {
    background-color: whitesmoke !important;
  }
}

@media screen and (max-width: 768px) {
  .columns.is-vcentered {
    align-items: normal;
  }
}

.logo {
  height: 40px;
}

@media screen and (min-width: 769px) {
  .logo {
    height: 96px;
  }
}
</style>
